import '../worker-loader';
import CanvasWorkerImporter = require('worker-loader?inline=true!./canvasworker');

export default CanvasWorkerImporter;
